/** @jsxImportSource @emotion/react */
import { PanelCard } from '../../../design-system/molecules/PanelCard/PanelCard';
import { Table } from '../../../design-system/molecules/Table/Table';
import { MeterBar } from '../../../design-system/molecules/MeterBar/MeterBar';
import type { MeterBarTone } from '../../../design-system/molecules/MeterBar/MeterBar';
import { Checkbox } from '../../../design-system/atoms/Checkbox/Checkbox';
import { Input } from '../../../design-system/atoms/Input/Input';
import { Button } from '../../../design-system/atoms/Button/Button';
import { Cluster } from '../../../design-system/layout/Cluster';
import type { ModuleHealth } from '../../types';
import { rowStyle, nameCellStyle, monoMutedStyle, mutedStyle, dangerStyle, warnStyle, actionCellStyle } from './ModuleHealthTable.styles';

export interface ModuleHealthTableProps {
  rows: ModuleHealth[];
  problemsOnly: boolean;
  onProblemsOnlyChange: (v: boolean) => void;
  searchText: string;
  onSearchChange: (v: string) => void;
  onOpenHistory?: (moduleName: string) => void;
}

/** 성공률 구간 → 게이지 색. 시안 rateBar 규칙(95/80 경계)에서 추출. */
function rateTone(rate: number): MeterBarTone {
  if (rate >= 95) return 'success';
  if (rate >= 80) return 'warning';
  return 'danger';
}

/** 모듈 파이프라인 상태 표. 스케줄·마지막 실행·성공률·다음 실행 요약에 활용. */
export function ModuleHealthTable({
  rows,
  problemsOnly,
  onProblemsOnlyChange,
  searchText,
  onSearchChange,
  onOpenHistory,
}: ModuleHealthTableProps) {
  return (
    <PanelCard
      flush
      collapsible
      title="모듈 파이프라인 상태"
      headerRight={
        <Cluster gap="sm">
          <Checkbox label="문제만 보기" checked={problemsOnly} onChange={onProblemsOnlyChange} />
          <Input placeholder="모듈 검색…" value={searchText} onChange={onSearchChange} />
        </Cluster>
      }
    >
      <Table headers={['모듈', '스케줄', '마지막 실행', '최근 성공률', '평균 소요', '다음 실행', '']}>
        {rows.map((m) => (
          <tr key={m.name} css={rowStyle(m.bad)}>
            <td css={nameCellStyle}>{m.name}</td>
            <td css={monoMutedStyle}>{m.cron}</td>
            <td css={m.bad ? dangerStyle : mutedStyle}>{m.last}</td>
            <td>
              <MeterBar percent={m.rate} tone={rateTone(m.rate)} label={`${m.rate}%`} />
            </td>
            <td css={mutedStyle}>{m.avg}</td>
            <td css={m.next.includes('지연') ? warnStyle : mutedStyle}>{m.next}</td>
            <td css={actionCellStyle}>
              <Button variant="text" onClick={() => onOpenHistory?.(m.name)}>
                이력
              </Button>
            </td>
          </tr>
        ))}
      </Table>
    </PanelCard>
  );
}
